import { injectIntl } from 'react-intl';

import LiveTrainInformation from './LiveTrainsInformation';

export default injectIntl(LiveTrainInformation);
